// import Button from "../../../Components/Buttons/Button";
// import Cross from '../../../Assets/Modals/closeIcon.svg';
// import PlusBlue from '../../../Assets/PlusIcon/AddBlue.svg';
// import { useDispatch } from "react-redux";
// import { closeModal } from "../../../Features/inventoryManagementSlice";
// import { EditSizeChartContext } from "../../../Context/EditSizeChartContext";
// import { useContext, useRef, useState } from "react";
// import Input from "../../../Components/Input/Input";
// import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick";

// function toCamelCase(text) {
//     return text
//         .toLowerCase()
//         .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
// }

// function AddColumn() {
//     const boxRef = useRef(null);
//     const dispatch = useDispatch();

//     useOutsideClickHandler(boxRef, () => {
//         dispatch(closeModal());
//     });

//     const defaultOptionList = [
//         {
//             id: "optionValue1",
//             value: "",
//             error: "",
//         },
//     ];

//     const [optionList, setOptionList] = useState(defaultOptionList);

//     const {
//         sizeChartFormData,
//         setSizeChartFormData,
//         setExtraColumnKeys,
//         selectedCategory,
//     } = useContext(EditSizeChartContext);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setOptionList((prevOptions) =>
//             prevOptions.map((option) =>
//                 option.id === name ? { ...option, value, error: "" } : option
//             )
//         );
//     };

//     function addInput() {
//         const newInput = {
//             id: `optionValue${optionList.length + 1}`,
//             value: "",
//             error: "",
//         };
//         setOptionList([...optionList, newInput]);
//     }

//     function handleClose() {
//         dispatch(closeModal());
//     }

//     function handleSave() {
//         let isValid = true;

//         const existingKeys = Object.keys(sizeChartFormData[0]).map((key) => key.toLowerCase());

//         const validatedList = optionList.map((item) => {
//             const trimmedValue = item.value.trim();
//             const camelKey = toCamelCase(trimmedValue).toLowerCase();

//             if (!trimmedValue) {
//                 isValid = false;
//                 return { ...item, error: "This field is required" };
//             }

//             if (existingKeys.includes(camelKey)) {
//                 isValid = false;
//                 return { ...item, error: "This column already exists" };
//             }

//             return { ...item, error: "" };
//         });

//         setOptionList(validatedList);

//         if (!isValid) {
//             return;
//         }

//         const extraColumnKeyList = optionList.map((item) => toCamelCase(item.value));

//         setExtraColumnKeys(extraColumnKeyList);

//         const extraColumns = extraColumnKeyList.reduce((acc, key, index) => {
//             const inputValue = optionList[index].value.trim();

//             if (selectedCategory === "Shoe & Sandals" || selectedCategory === "High Heels") {
//                 acc[key] = { sizeName: inputValue, cm: "", in: "" };
//             } else {
//                 acc[key] = { cm: "", in: "" };
//             }

//             return acc;
//         }, {});

//         const newFormData = sizeChartFormData.map(formData => (
//             {
//                 ...formData,
//                 ...extraColumns,
//             }
//         ));

//         setSizeChartFormData(newFormData);
//         dispatch(closeModal());
//     }

//     return (
//         <div ref={boxRef} className="w-[44%] bg-[#FFFFFF] rounded-[9px] p-6 pt-[18px] flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
//             <div className="flex flex-col gap-4">
//                 <div className="flex items-center justify-between">
//                     <p className="text-2xl font-semibold text-[#121212]">
//                         Add Column
//                     </p>

//                     <button
//                         className="size-11 p-[10px] flex items-center justify-center"
//                         onClick={handleClose}
//                     >
//                         <img src={Cross} alt="" />
//                     </button>
//                 </div>

//                 <div className="flex flex-col gap-3">
//                     <div className="flex flex-col gap-3 max-h-80 overflow-y-scroll">
//                         {optionList.map((option, index) => (
//                             <Input
//                                 key={option.id}
//                                 labelText={`Column title ${index + 1}`}
//                                 inputOptions={{
//                                     type: "text",
//                                     id: option.id,
//                                     name: option.id,
//                                     placeholder: "Enter value",
//                                     value: option.value,
//                                     onChange: handleChange,
//                                 }}
//                                 errorText={option.error}
//                             />
//                         ))}
//                     </div>

//                     <button onClick={addInput} className="flex items-center w-fit">
//                         <img
//                             className="size-6 flex items-center justify-center"
//                             src={PlusBlue}
//                             alt=""
//                         />
//                         <p className="text-base font-medium text-link">Add Input</p>
//                     </button>
//                 </div>
//             </div>

//             <Button label={"Save"} variant={"primary2"} onClick={handleSave} />
//         </div>
//     );
// }

// export default AddColumn;
import Button from "../../../Components/Buttons/Button";
import Cross from '../../../Assets/Modals/closeIcon.svg';
import PlusBlue from '../../../Assets/PlusIcon/AddBlue.svg';
import { useDispatch } from "react-redux";
import { closeModal } from "../../../Features/inventoryManagementSlice";
import { EditSizeChartContext } from "../../../Context/EditSizeChartContext";
import { useContext, useRef, useState } from "react";
import Input from "../../../Components/Input/Input";
import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick";

function toCamelCase(text) {
    return text
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
}

function AddColumn() {
    const boxRef = useRef(null);
    const dispatch = useDispatch();

    useOutsideClickHandler(boxRef, () => {
        dispatch(closeModal());
    });

    const defaultOptionList = [
        {
            id: "optionValue1",
            value: "",
            error: "",
        },
    ];

    const [optionList, setOptionList] = useState(defaultOptionList);

    const {
        sizeChartFormData,
        setSizeChartFormData,
        setExtraColumnKeys,
        selectedCategory,
    } = useContext(EditSizeChartContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setOptionList((prevOptions) =>
            prevOptions.map((option) =>
                option.id === name ? { ...option, value, error: "" } : option
            )
        );
    };

    function addInput() {
        const newInput = {
            id: `optionValue${optionList.length + 1}`,
            value: "",
            error: "",
        };
        setOptionList([...optionList, newInput]);
    }

    function handleClose() {
        dispatch(closeModal());
    }

    function handleSave() {
        let isValid = true;

        const existingKeys = Object.keys(sizeChartFormData[0]).map((key) => key.toLowerCase());

        const validatedList = optionList.map((item) => {
            const trimmedValue = item.value.trim();
            const camelKey = toCamelCase(trimmedValue).toLowerCase();

            if (!trimmedValue) {
                isValid = false;
                return { ...item, error: "This field is required" };
            }

            if (existingKeys.includes(camelKey)) {
                isValid = false;
                return { ...item, error: "This column already exists" };
            }

            return { ...item, error: "" };
        });

        setOptionList(validatedList);

        if (!isValid) {
            return;
        }

        const extraColumnKeyList = optionList.map((item) => toCamelCase(item.value));

        setExtraColumnKeys(extraColumnKeyList);

        const extraColumns = extraColumnKeyList.reduce((acc, key, index) => {
            const label = optionList[index].value.trim();

            acc[key] = { cm: "", in: "" };
            if (selectedCategory === "Shoe & Sandals" || selectedCategory === "High Heels") {
                acc[key].sizeName = label;
            }

            return acc;
        }, {});

        const newFormData = sizeChartFormData.map((formData) => ({
            ...formData,
            ...extraColumns,
        }));

        setSizeChartFormData(newFormData);
        dispatch(closeModal());
    }

    return (
        <div
            ref={boxRef}
            className="w-[44%] bg-[#FFFFFF] rounded-[9px] p-6 pt-[18px] flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]"
        >
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <p className="text-2xl font-semibold text-[#121212]">
                        Add Column
                    </p>

                    <button
                        className="size-11 p-[10px] flex items-center justify-center"
                        onClick={handleClose}
                    >
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-3 max-h-80 overflow-y-scroll">
                        {optionList.map((option, index) => (
                            <Input
                                key={option.id}
                                labelText={`Column title ${index + 1}`}
                                inputOptions={{
                                    type: "text",
                                    id: option.id,
                                    name: option.id,
                                    placeholder: "Enter value",
                                    value: option.value,
                                    onChange: handleChange,
                                }}
                                errorText={option.error}
                            />
                        ))}
                    </div>

                    <button onClick={addInput} className="flex items-center w-fit">
                        <img
                            className="size-6 flex items-center justify-center"
                            src={PlusBlue}
                            alt=""
                        />
                        <p className="text-base font-medium text-link">Add Input</p>
                    </button>
                </div>
            </div>

            <Button label={"Save"} variant={"primary2"} onClick={handleSave} />
        </div>
    );
}

export default AddColumn;
